import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { business } from "../../data/business";
import { UtilityBar } from "./UtilityBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileActionBar } from "./MobileActionBar";
const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "LegalService"],
  name: business.name,
  slogan: business.tagline,
  telephone: business.phoneE164,
  url: "https://www.postvegasbond.com/",
  address: {
    "@type": "PostalAddress",
    streetAddress: business.street,
    addressLocality: "Las Vegas",
    addressRegion: "NV",
    postalCode: "89109",
    addressCountry: "US"
  },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59"
  },
  areaServed: ["Las Vegas", "Henderson", "North Las Vegas", "Clark County"],
  sameAs: [business.facebookUrl]
};
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({
          behavior: "smooth",
          block: "start"
        }));
        return;
      }
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-white pb-[calc(60px+env(safe-area-inset-bottom))] md:pb-0" data-id="element-390" data-mp="3r2f5397pwiby">
      <a href="#main" className="sr-only z-[60] rounded-full bg-gold px-5 py-3 font-semibold text-navy focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-id="element-391" data-mp="2kmupnide93p8">
        Skip to content
      </a>
      <UtilityBar data-id="element-392" data-mp="17ouh88512y97" />
      <Header data-id="element-393" data-mp="17oawykrwnxs0" />
      <main id="main" className="flex-1" data-id="element-394" data-mp="17los4swefwdh">
        <Outlet data-id="element-395" data-mp="1bpwh8r6rrec8" />
      </main>
      <Footer data-id="element-396" data-mp="1bo3cxijmp67e" />
      <MobileActionBar data-id="element-397" data-mp="1bolfewwvwgnr" />
    </div>;
}